export const classes = {
  cell: 'py-4 border-none',
};
